export const environment = {
    production: false,
    endpoint: 'https://apiflyer.amerimont.com'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts